import { api } from './client';
import { dashboardViewSchema, type DashboardView } from './types';

export async function fetchDashboard(signal?: AbortSignal): Promise<DashboardView> {
  const body = await api.get<unknown>('/dashboard', { ...(signal ? { signal } : {}) });
  return dashboardViewSchema.parse(body);
}
